import { useQuery } from "@tanstack/react-query"

export function useVipSupportEligibility(address: string | undefined) {
  const { data, isLoading } = useQuery({
    queryKey: ["founding-trader-eligibility", address],
    queryFn: async () => {
      const res = await fetch("/api/vip-support/eligible")
      if (!res.ok) throw new Error("Failed to check VIP support eligibility")
      return res.json() as Promise<{ eligible: boolean }>
    },
    staleTime: 5 * 60 * 1000,
    enabled: !!address,
  })

  return { isEligible: data?.eligible ?? false, isLoading }
}
